import React, { Component } from "react";
import Appointment from "../../../components/Appointment/Appointment";

class AppointmentPage extends Component{
    render(){
        return(
            <div>                    
                <Appointment/>
            </div>
        )   
    }
}

export default AppointmentPage;